// extracted by mini-css-extract-plugin
export default {"link":"internal-link-module--link--86247"};